
export const fichaSearchReducer = (state = {}, action) => {
    switch(action.type){
        case "ficha_search/set": {
            return action.payload;
        }
        default:
            return state
    }
}